import React, { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';

function normalizeCode(raw) {
  return (raw || '').trim().toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 12);
}

export default function BachecaJoin() {
  const navigate = useNavigate();
  const [raw, setRaw] = useState('');

  const code = useMemo(() => normalizeCode(raw), [raw]);
  const valid = /^[A-Z0-9]{4,12}$/.test(code);

  return (
    <div className="h-[100dvh] overflow-y-auto bg-background text-foreground flex items-center justify-center p-6">
      <Card className="w-full max-w-md">
        <CardContent className="p-6">
          <div className="text-lg font-semibold">Partecipa alla bacheca</div>
          <div className="mt-1 text-sm text-muted-foreground">Inserisci il codice dato dal docente.</div>

          <div className="mt-4">
            <div className="text-sm font-medium mb-1">Codice</div>
            <Input
              value={raw}
              onChange={(e) => setRaw(e.target.value)}
              placeholder="Es. 7K2P9A"
              className="font-mono"
            />
            <div className="mt-2 text-xs text-muted-foreground">Sono ammessi solo lettere e numeri.</div>
          </div>

          <Button
            className="mt-4 w-full"
            disabled={!valid}
            onClick={() => navigate(`/b/${code}`)}
          >
            Entra
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
